import { useTranslation } from "react-i18next";
import styles from "./RulesFragment.module.css";
import Card from "../../common/Card";

const RulesFragment = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<Card title={t("rules.card.rules.title")}>
				<p
					style={{
						padding: "10px",
						backgroundColor: "#f2f2f2",
						borderRadius: "10px",
						marginBottom: "20px",
					}}
					dangerouslySetInnerHTML={{ __html: t("rules.temporary_notice") }}
				/>

				<p dangerouslySetInnerHTML={{ __html: t("rules.intro") }} />
				<ol className={styles.rulesList}>
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule1") }} />
					<li>
						<span dangerouslySetInnerHTML={{ __html: t("rules.rule2.main") }} />
						<ol className={styles.nestedList} type="a">
							<li dangerouslySetInnerHTML={{ __html: t("rules.rule2.a") }} />
							<li dangerouslySetInnerHTML={{ __html: t("rules.rule2.b") }} />
							<li dangerouslySetInnerHTML={{ __html: t("rules.rule2.c") }} />
							<li dangerouslySetInnerHTML={{ __html: t("rules.rule2.d") }} />
							<li dangerouslySetInnerHTML={{ __html: t("rules.rule2.e") }} />
						</ol>
					</li>
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule3") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule4") }} />
				</ol>
			</Card>

			<Card title={t("rules.card.pointsAllocation.title")}>
				<div className={styles.pointsTable}>
					<div className={styles.pointsRow}>
						<div dangerouslySetInnerHTML={{ __html: t("rules.points.correctScore") }} />
						<div className={styles.pointValue}>{t("rules.points.correctScoreValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div dangerouslySetInnerHTML={{ __html: t("rules.points.correctWinner") }} />
						<div className={styles.pointValue}>{t("rules.points.correctWinnerValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div dangerouslySetInnerHTML={{ __html: t("rules.points.homeGoals") }} />
						<div className={styles.pointValue}>{t("rules.points.homeGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div dangerouslySetInnerHTML={{ __html: t("rules.points.awayGoals") }} />
						<div className={styles.pointValue}>{t("rules.points.awayGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div dangerouslySetInnerHTML={{ __html: t("rules.points.goalDifference") }} />
						<div className={styles.pointValue}>{t("rules.points.goalDifferenceValue")}</div>
					</div>
				</div>
			</Card>

			<Card title={t("rules.card.rulesContinued.title")}>
				<ol className={styles.rulesList} start="5">
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule5") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule6") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule7") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule8") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule9") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule10") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule11") }} />
				</ol>
			</Card>

			<Card title={t("rules.card.weeklyPrizes.title")}>
				<div className={styles.weeklyPrizesTable}>
					<div className={styles.tableRow}>
						<div>{t("rules.weeklyPrizes.header.position")}</div>
						<div>{t("rules.weeklyPrizes.header.eur")}</div>
						<div>{t("rules.weeklyPrizes.header.gbp")}</div>
						<div>{t("rules.weeklyPrizes.header.zar")}</div>
						<div>{t("rules.weeklyPrizes.header.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>1</div>
						<div>{t("rules.weeklyPrizes.position1.eur")}</div>
						<div>{t("rules.weeklyPrizes.position1.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position1.zar")}</div>
						<div>{t("rules.weeklyPrizes.position1.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>2</div>
						<div>{t("rules.weeklyPrizes.position2.eur")}</div>
						<div>{t("rules.weeklyPrizes.position2.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position2.zar")}</div>
						<div>{t("rules.weeklyPrizes.position2.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>3</div>
						<div>{t("rules.weeklyPrizes.position3.eur")}</div>
						<div>{t("rules.weeklyPrizes.position3.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position3.zar")}</div>
						<div>{t("rules.weeklyPrizes.position3.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>4</div>
						<div>{t("rules.weeklyPrizes.position4.eur")}</div>
						<div>{t("rules.weeklyPrizes.position4.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position4.zar")}</div>
						<div>{t("rules.weeklyPrizes.position4.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>5</div>
						<div>{t("rules.weeklyPrizes.position5.eur")}</div>
						<div>{t("rules.weeklyPrizes.position5.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position5.zar")}</div>
						<div>{t("rules.weeklyPrizes.position5.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>6</div>
						<div>{t("rules.weeklyPrizes.position6.eur")}</div>
						<div>{t("rules.weeklyPrizes.position6.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position6.zar")}</div>
						<div>{t("rules.weeklyPrizes.position6.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>7</div>
						<div>{t("rules.weeklyPrizes.position7.eur")}</div>
						<div>{t("rules.weeklyPrizes.position7.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position7.zar")}</div>
						<div>{t("rules.weeklyPrizes.position7.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>8</div>
						<div>{t("rules.weeklyPrizes.position8.eur")}</div>
						<div>{t("rules.weeklyPrizes.position8.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position8.zar")}</div>
						<div>{t("rules.weeklyPrizes.position8.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>9</div>
						<div>{t("rules.weeklyPrizes.position9.eur")}</div>
						<div>{t("rules.weeklyPrizes.position9.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position9.zar")}</div>
						<div>{t("rules.weeklyPrizes.position9.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>10</div>
						<div>{t("rules.weeklyPrizes.position10.eur")}</div>
						<div>{t("rules.weeklyPrizes.position10.gbp")}</div>
						<div>{t("rules.weeklyPrizes.position10.zar")}</div>
						<div>{t("rules.weeklyPrizes.position10.ghs")}</div>
					</div>
				</div>
			</Card>

			<Card title={t("rules.card.rulesContinued.title")}>
				<ol className={styles.rulesList} start="12">
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule12") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule13") }} />
					<li dangerouslySetInnerHTML={{ __html: t("rules.rule14") }} />
				</ol>
			</Card>
		</div>
	);
};

export default RulesFragment;
